import { render, staticRenderFns } from "./CategoriaModule.vue?vue&type=template&id=9cb6904c"
import script from "./CategoriaModule.vue?vue&type=script&lang=js"
export * from "./CategoriaModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports